import React, { useRef, useEffect, useState } from 'react';
import { Main } from "./main"
import { Activity } from "./activity"
import { Footer, NavBar } from "./html"
import { Login } from "./login"
import { Dialog } from "./dialog"
import { PrevDialog } from "./prevDialog"
import { InfoDialog } from "./infoDialog"

export let Ref = {
  timers: {}
};
window.ref = Ref;

async function fetchx(url, json) {
  let send = {};
  
  if(json) {
    send.method = "POST";
    send.body = JSON.stringify(json);
    send.headers = { 'Content-Type': 'application/json' };
    send.credentials = "same-origin";
  }
  else {
    send.method = "GET"
  }

  return await fetch(url, send);
}

window.fetchj = async (url, json) => {
  let response = {};
  const msg1 = "Požadavek se nepodařilo načíst (404). Zkontrolujte připojení k internetu.";
  const mgs2 = "Chyba: zkontrolujte připojení k internetu!";

  try {
    response = await fetchx(url, json);

    if(response.status != 200) {
      let txt = response.statusText;

      if(response.statusText.includes("NetworkError")) {
        txt = msg1;
      }
      Ref.InfoDialog.current.show("Chyba ze serveru: " + txt);
      return {};
    }

    const res = await response.json();

    if(res.login === false) {
      logout();
    }

    return res;
  }
  catch(e) {
    const errorMsg = response ? (response.status == "404" ? msg1 : e.message) : mgs2;

    return {
      error: true,
      errorMsg, e,
      errorType: "fetchJSON",
      res: response
    }
  }
}

async function logout() {
  const res = await window.fetch("/logout");
  Object.values(Ref.timers).forEach(f => clearInterval(f));
  Ref.timers = {};
  Ref.setLogin("");
}

function useFetch(url) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  
  useEffect(() => {
    (async () => {
      const response = await fetch(url);
      const json = await response.json();
      setData(json);
      setLoading(false);
    })();
  }, []);
  return [data, loading];
}

function App() {
  document.onclick =e=> {
    if(e.target.id != "user-logout") {
      const cUser = document.getElementsByClassName("current-user")[0];
      cUser && cUser.classList.remove("open")
    }
  }
  
  const [loginInfo, setLogin] = useState({});

  Ref.Dialog     = useRef();
  Ref.PrevDialog = useRef();
  Ref.InfoDialog = useRef();
  Ref.Act        = useRef({});
  Ref.Pages      = useRef({});
  Ref.AtchList   = useRef({});
  Ref.setLogin   = setLogin;

  return (
    <div className="App">
      { loginInfo.login ?
        <>
          <NavBar userName={loginInfo.user} setLogin={setLogin} />
          <Dialog ref={Ref.Dialog} />
          <PrevDialog ref={Ref.PrevDialog} />
          <InfoDialog ref={Ref.InfoDialog} />
          <Main>
            <Activity ref={Ref.Act} />
          </Main>
        </> : 
        <Login setLogin={setLogin} />
      }
    </div>
  );
}

export default App;
